import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SplashLogin from "./SplashLogin";

import Sophie from "../Bots/Sophie.jpg";
import Eleanor from "../Bots/Eleanor.jpg";
import Thomas from "../Bots/Thomas.jpg";
import Margaret from "../Bots/Margaret.jpg";

const SEQUENCE = [
  { bot: "Eleanor", avatar: Sophie, text: "Reading your company policies and procedures", type: "progress" },
  { bot: "Eleanor", avatar: Eleanor, text: "Checking latest guidance from the CQC", type: "progress" },
  { bot: "Thomas", avatar: Thomas, text: "Reading expert documents", type: "docs", max: 1012 },
  { bot: "Margaret", avatar: Margaret, text: "Reviewing compliance updates", type: "progress" },
  { bot: "System", text: "All done.", type: "final" },
];

export default function SplashScreen({ onLoginSuccess }) {
  const [step, setStep] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (step < SEQUENCE.length - 1) {
      const timer = setTimeout(() => setStep(step + 1), 2200);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => setShowLogin(true), 1200);
      return () => clearTimeout(timer);
    }
  }, [step]);

  useEffect(() => {
    const current = SEQUENCE[step];
    if (current.type === "progress" || current.type === "docs") {
      const max = current.max || 100;
      setCounter(0);
      let val = 0;
      const interval = setInterval(() => {
        val += Math.ceil(max / 40);
        if (val >= max) {
          val = max;
          clearInterval(interval);
        }
        setCounter(val);
      }, 40);
      return () => clearInterval(interval);
    }
  }, [step]);

  const current = SEQUENCE[Math.min(step, SEQUENCE.length - 1)];

  return (
    <div className="flex flex-col items-center justify-between h-screen bg-gradient-to-br from-[#0a3d62] via-[#052c47] to-black text-white overflow-hidden relative">
      {/* Fixed Logo at Top */}
      <div className="pt-10">
        <img
          src="https://cqcexperts.com/wp-content/uploads/2021/07/CQCexperts-Logo.svg"
          alt="CQC Experts Logo"
          className="w-56 drop-shadow-md"
        />
      </div>

      {/* Bot animation */}
      <AnimatePresence mode="wait">
        {!showLogin && (
          <motion.div
            key={step}
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -25 }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-center justify-center flex-grow"
          >
            {current.bot !== "System" && current.avatar && (
              <motion.img
                src={current.avatar}
                alt={current.bot}
                className="w-28 h-28 rounded-full mb-4 shadow-xl object-cover"
                initial={{ scale: 0.85, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6 }}
              />
            )}

            <p className="text-lg md:text-xl font-light text-center mb-2">
              {current.text}
            </p>

            {current.type === "progress" && (
              <motion.div className="text-lg text-cyan-300 font-semibold">
                {counter}%
              </motion.div>
            )}

            {current.type === "docs" && (
              <motion.div className="text-lg text-amber-300 font-semibold">
                Documents read: {counter}
              </motion.div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Login form */}
      {showLogin && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="absolute inset-0 flex items-center justify-center z-20 px-4"
        >
          <SplashLogin onLoginSuccess={onLoginSuccess} />
        </motion.div>
      )}
    </div>
  );
}
